import { Component, OnInit } from '@angular/core';
import { FormValidationService, ErrorHandlingService, ValidationError } from 'core-lib';
import { AlertService, FormValidator, LocalParserFormatter } from 'core-lib';
import { PermitService, PermitDetailsModel, PermitDetailsVehicleItemModel } from '../services/permit.service';
import { Router } from '@angular/router';

import * as moment from 'moment';
import * as _ from 'lodash';
import { environment } from '../../environments/environment';



@Component({
  selector: 'cli-permit-renew',
  templateUrl: './permit-renew.component.html',
  styleUrls: ['./permit-renew.component.scss']
})
export class PermitRenewComponent implements OnInit {

  public vm: PermitRenewModalViewModel;
  private validator: FormValidator;
  private permit: PermitDetailsModel;

  constructor(private formatter: LocalParserFormatter,
    private alertSvc: AlertService,
    private formValidationSvc: FormValidationService,
    private permitSvc: PermitService,
    private errorHandilingSvc: ErrorHandlingService,
    private router: Router) {

    this.vm = new PermitRenewModalViewModel();
    this.validator = this.formValidationSvc.getFormValidator(this.vm);

    this.vm.isOpening = true;
  }

  ngOnInit() {

    if (this.permitSvc.model == null) {
      this.vm.isLoading = true;
    }

    this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {

      this.permit = data;

      this.vm.businessName = data.permitDetails.clientName;
      this.vm.contactName = data.permitDetails.firstName + ' ' +  data.permitDetails.lastName
      this.vm.permitNo = data.permitDetails.permitNo;

      this.loadData();

    },
      (e) => { this.errorHandilingSvc.processHttpError(e); })
      .finally(() => { this.vm.isLoading = false; this.vm.isOpening = false; });

  }

  loadData() {


    this.vm.vehicles = _(this.permit.vehicles)
      .filter((v: PermitDetailsVehicleItemModel) => v.status === 'Active')
      .sortBy((n: PermitDetailsVehicleItemModel) => n.rego)
      .map((v: PermitDetailsVehicleItemModel) => {

        let rv = new RenewVehicleViewModel();
        rv.vehicleId = v.vehicleId;
        rv.capacity = v.capacity;
        rv.vehicleType = v.vehicleType;
        rv.vehicleMake = v.vehicleMake;
        rv.regoNo = v.rego;
        rv.deviceNo = v.deviceNo;

        return rv;
      }).value();
  }

  public proceedYes() {

    this.validate().then(() => {

      let permitId = this.permit.permitDetails.permitId;
      let vehicleIds = _(this.vm.vehicles)
        .filter((n: RenewVehicleViewModel) => { return n.isRenew; })
        .map((n: RenewVehicleViewModel) => n.vehicleId)
        .value();

      this.vm.isLoading = true;

      this.permitSvc.renewPermit(permitId, vehicleIds)

        .toPromise().then(() => {

          return this.permitSvc.getDetails(true).toPromise().then(() => {

            this.alertSvc.success(environment.TOASTR_HEADER, 'The permit was successfully renewed.');
            this.router.navigate(['/app/vehicles']);
          },
            (e) => {
              let errormessage = this.errorHandilingSvc.processHttpError(e);
              return Promise.reject(errormessage);

            });

        },
          (e) => { this.errorHandilingSvc.processHttpError(e); }).finally(() => { this.vm.isLoading = false; });

    },
      (e) => { });

  }

  public proceedCancel() {

    this.router.navigate(['/app/vehicles']);
  }


  public renewAll() {
    _.each(this.vm.vehicles, (v: RenewVehicleViewModel) => { v.isRenew = true; });
  }

  validate(): Promise<void> {
    this.vm.errors = [];

    this.validator.validateCustom('form', 'No vehicles selected. Please select vehicles to renew',
      () => {
        return !_.find(this.vm.vehicles, (v: RenewVehicleViewModel) => {
          return v.isRenew;
        });
      });

    if (this.vm.errors.length === 0) { return Promise.resolve(); }

    return Promise.reject('Invalid input');
  }

}


export class PermitRenewModalViewModel {
  constructor() {
    this.errors = [];
  }
  public errors: ValidationError[];

  public businessName: string;
  public contactName: string;
  public permitNo: string;
  public isLoading: boolean;
  public isOpening: boolean;
  public isRenewAll: boolean;

  public vehicles: RenewVehicleViewModel[];
}

export class RenewVehicleViewModel {

  public vehicleId: string;
  public regoNo: string;
  public capacity: number;
  public vehicleType: string;
  public vehicleMake: string;
  public deviceNo: string;
  public isRenew: boolean;

}
